import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { getNavigationInterceptor } from 'src/hooks/use-navigation-interceptor';

// ----------------------------------------------------------------------

export function useRouter() {
  const navigate = useNavigate();

  const router = useMemo(
    () => ({
      back: async () => {
        const interceptor = getNavigationInterceptor();
        if (interceptor) {
          const canNavigate = await interceptor();
          if (!canNavigate) {
            return; // Block navigation
          }
        }
        navigate(-1);
      },
      forward: async () => {
        const interceptor = getNavigationInterceptor();
        if (interceptor) {
          const canNavigate = await interceptor();
          if (!canNavigate) {
            return; // Block navigation
          }
        }
        navigate(1);
      },
      reload: async () => {
        const interceptor = getNavigationInterceptor();
        if (interceptor) {
          const canNavigate = await interceptor();
          if (!canNavigate) {
            return; // Block navigation
          }
        }
        window.location.reload();
      },
      push: async (href: string) => {
        const interceptor = getNavigationInterceptor();
        if (interceptor) {
          const canNavigate = await interceptor();
          if (!canNavigate) {
            return; // Block navigation
          }
        }
        navigate(href);
      },
      replace: async (href: string) => {
        const interceptor = getNavigationInterceptor();
        if (interceptor) {
          const canNavigate = await interceptor();
          if (!canNavigate) {
            return; // Block navigation
          }
        }
        navigate(href, { replace: true });
      },
    }),
    [navigate]
  );

  return router;
}
